import React from 'react';
import { stats } from '../data/mock';

const Stats = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-[var(--niko-teal-dark)] to-[var(--niko-teal)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-4xl lg:text-5xl font-bold text-white mb-2">
                {stat.value}
              </p>
              <p className="text-lg font-medium text-white/90 mb-1">
                {stat.label}
              </p>
              <p className="text-sm text-white/60">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
